module.exports = __webpack_public_path__ + "img/loading.00238d9c.gif";